/**
 * Shared Featured Carousel strip skeleton — Add ghost preview + live edit
 * refetch (matches CarouselSection loading tiles).
 */
import React from "react";
import type { CarouselData } from "./types";

export function featuredCarouselStripIsProductish(
  carousel?: CarouselData | null,
  opts?: {
    preferFeed?: string;
    sectionIdHint?: string;
  },
): boolean {
  const typeLc = String(carousel?.componentType || "")
    .trim()
    .toLowerCase();
  const preferFeed = String(opts?.preferFeed || "")
    .trim()
    .toLowerCase();
  const sectionIdHint = String(opts?.sectionIdHint || "")
    .trim()
    .toLowerCase();
  if (
    typeLc === "all" ||
    typeLc === "reels" ||
    typeLc === "instagram story" ||
    typeLc === "tiktok" ||
    typeLc === "youtube" ||
    typeLc === "twitter" ||
    typeLc === "linkedin" ||
    typeLc === "podcast" ||
    typeLc === "latest-podcast" ||
    typeLc === "featured"
  ) {
    return false;
  }
  return (
    preferFeed === "recent-products" ||
    sectionIdHint === "carouselproducts" ||
    carousel?.type === "shop" ||
    typeLc === "trending products" ||
    typeLc === "shoppable" ||
    typeLc === "links" ||
    typeLc === "query-links"
  );
}

export function featuredCarouselIsTrendingFeed(
  carousel?: CarouselData | null,
): boolean {
  const typeLc = String(carousel?.componentType || "")
    .trim()
    .toLowerCase();
  return typeLc === "trending content" || typeLc === "trending products";
}

export function FeaturedCarouselStripSkeleton({
  count = 5,
  product = false,
  square = false,
}: {
  count?: number;
  product?: boolean;
  square?: boolean;
}) {
  return (
    <div
      className="mte-tpl-fc-strip"
      data-fc-mode="collection"
      aria-hidden="true"
    >
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={`mte-tpl-fc-card mte-tpl-fc-card--static mte-tpl-fc-card--skel${
            product ? " mte-tpl-fc-card--product" : ""
          }${square ? " mte-tpl-fc-card--square" : ""}`}
          style={{ animationDelay: `${i * 80}ms` }}
        >
          {product ? (
            <>
              <div className="mte-tpl-fc-media-shell">
                <div className="mte-tpl-fc-media is-product is-loading">
                  <div className="mte-tpl-skel-fill mte-tpl-skel-fill--cover mte-tpl-fc-media-skel" />
                </div>
              </div>
              <div className="mte-tpl-fc-product-meta" aria-hidden>
                <div className="mte-tpl-skel-line mte-tpl-skel-line--label" />
                <div className="mte-tpl-skel-line mte-tpl-skel-line--sm" />
              </div>
            </>
          ) : (
            <div className="mte-tpl-skel-fill mte-tpl-skel-fill--cover mte-tpl-fc-media-skel" />
          )}
        </div>
      ))}
    </div>
  );
}
